export { default as SlidingEyebrow } from './SlidingEyebrow'



// WEBPACK FOOTER //
// ./src/components/slidingEyebrow/index.js